import { render, staticRenderFns } from "./MzStar1.vue?vue&type=template&id=e548b18c&"
import script from "./MzStar1.vue?vue&type=script&lang=js&"
export * from "./MzStar1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports